import { createTheme } from "@material-ui/core/styles";
import { colors } from "@material-ui/core/";
import shadows from "./shadows";
import typography from "./typography";

const theme = createTheme({
  palette: {
    background: {
      default: "#F4F6F8",
      paper: colors.common.white,
    },
    primary: {
      main: "#f54e51",
    },
    secondary: {
      main: "#2D3133",
    },
    text: {
      primary: "#172b4d",
      secondary: "#6b778c",
    },
  },
  shadows,
  typography,
});

export default theme;
